import { createElement } from 'react'
import OpensearchOptimization from '~/dashboard/aws_master_optimizations/opensearch_optimization'
import ReactController from './react_controller'

export default class AWSOpensearchOptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(OpensearchOptimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
